import { useERPUI } from '../components/providers/ERPUIProvider';

/**
 * Hook to determine Redux integration status and provide conditional Redux usage
 */
export const useReduxIntegration = () => {
  const { useRedux, apiClient } = useERPUI();
  
  // Helper function to conditionally use Redux hooks
  const useConditionalRedux = <T>(
    reduxHook: () => T,
    fallbackValue: T
  ): T => {
    if (!useRedux) {
      return fallbackValue;
    }
    
    try {
      return reduxHook();
    } catch (error) {
      console.warn('Redux hook failed, falling back to default value:', error);
      return fallbackValue;
    }
  };
  
  // Helper function to conditionally dispatch Redux actions
  const conditionalDispatch = (action: any) => {
    if (!useRedux) {
      console.warn('Redux not enabled, cannot dispatch action:', action);
      return Promise.resolve();
    }
    
    try {
      const { useAppDispatch } = require('../redux/hooks');
      const dispatch = useAppDispatch();
      return dispatch(action);
    } catch (error) {
      console.error('Failed to dispatch Redux action:', error);
      return Promise.reject(error);
    }
  };
  
  return {
    useRedux,
    apiClient,
    useConditionalRedux,
    conditionalDispatch,
  };
};